import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from "../authConfig";

export class BaseService {

    public getAuthorizedRequestHeaders = async (instance: IPublicClientApplication): Promise<Headers> => {
        const account = instance.getActiveAccount();
        if (!account) {
            throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
        }

        const response = await instance.acquireTokenSilent({
            ...apiRequest,
            account: account
        });

        const headers = new Headers();
        const bearer = `Bearer ${response.accessToken}`;

        headers.append("Authorization", bearer);

        return headers;
    }
}
